// @flow

import LifeInsuranceService from 'web-core/src/life-insurance-service';
import type { Dispatch } from 'redux';

export const RECEIVE_LIFE_PLAN = 'RECEIVE_LIFE_PLAN';

export const receiveLifePlan = (lifePlan: Object) => ({
  type: RECEIVE_LIFE_PLAN,
  lifePlan,
});

type LifeAction = {
  type: 'RECEIVE_LIFE_PLAN',
  lifePlan: Object,
};

export function fetchLifeQuote(dob: string, gender: string, tobacco: string, health: number) {
  return (dispatch: Dispatch<LifeAction>, getState: () => Object, { apiClient }: Object) => {
    const svc = new LifeInsuranceService({ client: apiClient });
    return svc.getQuotes({ dob, gender, tobacco, health });
  };
}

// TODO: Colocate better
type FetchPlanResponse = {
  ethosApp: Object | null,
  strideApp: Object | null,
};

export function fetchPlanWithThirdPartyDetails() {
  return (dispatch: Dispatch<LifeAction>, getState: () => Object, { apiClient }: Object) => {
    const svc = new LifeInsuranceService({ client: apiClient });
    return svc
      .getPlanInfo()
      .then((response: FetchPlanResponse) => {
        if (response.strideApp) {
          const newPlanWithThirdPartyDetails = response.strideApp;
          // ethos app key's value is either null,
          // or a display status when it is received from web-core
          newPlanWithThirdPartyDetails.ethosApp =
            response.ethosApp && response.ethosApp.displayStatus !== 'Application Started'
              ? response.ethosApp
              : {};

          dispatch(receiveLifePlan(newPlanWithThirdPartyDetails));
        } else {
          dispatch(receiveLifePlan({}));
        }
      })
      .catch(() => dispatch(receiveLifePlan({})));
  };
}

// TODO: Colocate better
type LifePlanType = {
  coverage: number,
  created_on: string,
  ethos_health_status: number,
  monthly_premium: number,
  plan_url: string,
  primary_member_id: string,
  term_years: number,
  updated_on: string,
};

export function createOrUpdateLifePlan({
  coverage,
  familyHistory: family_history,
  height,
  householdIncome: household_income,
  monthlyCost: monthly_premium,
  planUrl: plan_url,
  termYears: term_years,
  weight,
}: {
  coverage: number,
  familyHistory: boolean,
  height: number,
  householdIncome: number,
  monthlyCost: number,
  planUrl: string,
  termYears: number,
  weight: number,
}) {
  return (dispatch: Dispatch<LifeAction>, getState: () => Object, { apiClient }: Object) => {
    const svc = new LifeInsuranceService({ client: apiClient });
    return svc
      .postPlan({
        term_years,
        coverage,
        monthly_premium,
        plan_url,
        family_history,
        household_income,
        height,
        weight,
      })
      .then((lifePlan: LifePlanType) => dispatch(receiveLifePlan(lifePlan)));
  };
}

export function fetchLife() {
  return (dispatch: Dispatch<LifeAction>, getState: () => Object, { apiClient }: Object) => {
    const svc = new LifeInsuranceService({ client: apiClient });
    return svc.getPlan().then((lifePlan: LifePlanType) => dispatch(receiveLifePlan(lifePlan)));
  };
}
